import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PendingFollowUpModal = ({ isOpen, onClose, onScheduleFollowUp }) => {
  const [followUp, setFollowUp] = useState({
    clientId: '',
    followUpDate: '',
    followUpTime: '',
    method: '',
    priority: '',
    notes: '',
    reminder: ''
  });

  const handleChange = (field, value) => {
    setFollowUp(prev => ({ ...prev, [field]: value }));
  };

  const handleSchedule = () => {
    onScheduleFollowUp?.(followUp);
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="إدارة المتابعات المعلقة" 
      size="md"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-4">
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-amber-400">
            <Icon name="Clock" size={20} />
            <span className="font-semibold">جدولة متابعة جديدة</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">رقم العميل</label>
          <Input
            placeholder="مثال: CL-2026-001"
            value={followUp?.clientId}
            onChange={(e) => handleChange('clientId', e?.target?.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ المتابعة</label>
            <Input
              type="date"
              value={followUp?.followUpDate}
              onChange={(e) => handleChange('followUpDate', e?.target?.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">وقت المتابعة</label>
            <Input
              type="time"
              value={followUp?.followUpTime}
              onChange={(e) => handleChange('followUpTime', e?.target?.value)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">طريقة المتابعة</label>
          <Select
            value={followUp?.method}
            onChange={(e) => handleChange('method', e?.target?.value)}
          >
            <option value="">اختر الطريقة</option>
            <option value="call">مكالمة هاتفية</option>
            <option value="whatsapp">واتساب</option>
            <option value="email">بريد إلكتروني</option>
            <option value="meeting">اجتماع شخصي</option>
            <option value="video">مكالمة فيديو</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الأولوية</label>
          <Select
            value={followUp?.priority}
            onChange={(e) => handleChange('priority', e?.target?.value)}
          >
            <option value="">اختر الأولوية</option>
            <option value="high">عالية</option>
            <option value="medium">متوسطة</option>
            <option value="low">منخفضة</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">التذكير قبل</label>
          <Select
            value={followUp?.reminder}
            onChange={(e) => handleChange('reminder', e?.target?.value)}
          >
            <option value="">بدون تذكير</option>
            <option value="15">15 دقيقة</option>
            <option value="30">30 دقيقة</option>
            <option value="60">ساعة واحدة</option>
            <option value="1440">يوم واحد</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">ملاحظات</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
            placeholder="أضف ملاحظات حول المتابعة..."
            value={followUp?.notes}
            onChange={(e) => handleChange('notes', e?.target?.value)}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleSchedule} className="flex-1">
            <Icon name="Calendar" size={18} className="ml-2" />
            جدولة المتابعة
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PendingFollowUpModal;